<template>
    <div class="braintree-fields row" v-show="payment_method === 'braintree_credit_card'">

        <div class="form-group required has-success col-sm-12 field-input">
            <label for="braintree_credit_card_number">Številka kartice
            </label>
            <div class="field-wrap">
                <div class="wrapper">
                    <div id="braintree_credit_card_number" class="form-control"></div>
                    <span class="helper-text"></span>
                </div>
            </div>
        </div>


        <div class="form-group required has-success col-sm-3 field-input">
            <label for="braintree_credit_card_number">Veljavnost (MM)
            </label>
            <div class="field-wrap">
                <div class="wrapper">
                    <div id="braintree_credit_card_expiration_date_month" class="form-control"></div>
                    <span class="helper-text"></span>
                </div>
            </div>
        </div>


        <div class="form-group required has-success col-sm-3 field-input">
            <label for="braintree_credit_card_number">Veljavnost (LL)
            </label>
            <div class="field-wrap">
                <div class="wrapper">
                    <div id="braintree_credit_card_expiration_date_year" class="form-control"></div>
                    <span class="helper-text"></span>
                </div>
            </div>
        </div>


        <div class="form-group required has-success col-sm-6 field-input">
            <label for="braintree_credit_card_number">CVV/CVC2*
            </label>
            <div class="field-wrap">
                <div class="wrapper">
                    <div id="braintree_credit_card_cvv" class="form-control"></div>
                    <span class="helper-text"></span>
                </div>
            </div>
        </div>



    </div>

</template>

<script>


    import {abstractField} from "vue-form-generator/dist/vfg-core.js";

    export default {
        mixins: [abstractField],

        data: function() {
            return {
                payment_method: ""
            }
        },

        created() {
            Event.$on("braintree_payment_method_changed", function(model){
                console.log(model.payment_method);
                this.payment_method = model.payment_method
            }.bind(this));
        }

    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/fields/fieldBraintree.vue